// src/components/PrivateRoute.jsx
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext.jsx';

function PrivateRoute({ children, requiredUserType }) {
  const { user } = useContext(AuthContext);
  
  if (!user) {
    // Si no hay usuario logueado, redirige a login
    return <Navigate to="/login" />;
  }
  
  if (requiredUserType && user.userType) {
    // Comparación case-insensitive
    if (user.userType.toLowerCase() !== requiredUserType.toLowerCase()) {
      // Redirige a la cuenta correspondiente según el userType real
      return (
        <Navigate
          to={user.userType.toLowerCase() === 'employer' ? '/mi-cuenta-empleador' : '/mi-cuenta-usuario'}
        />
      );
    }
  }
  
  return children;
}

export default PrivateRoute;